import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useSessionsStatistics(filters) {
  const initialState = {
    count: {
      Completed: 0,
      'Only Completed': 0,
      'Not Started': 0,
      'In Progress': 0,
      Undelivered: 0,
      Skipped: 0,
    },
    total: 0,
    percent: {
      Completed: 0,
      'Not Started': 0,
      'In Progress': 0,
      Skipped: 0,
    },
  };
  const [data, setData] = useState(initialState);
  const [loading, setLoading] = useState(false);

  const params = {
    policy_plan_id: filters.policyPlanId,
    team_id: filters.teamId,
    cycle_id: filters.cycleId,
  };

  useEffect(() => {
    setLoading(true);

    axios
      .get(routes.api.managers.dashboard.sessions_statistics, { params })
      .then((response) => {
        setData(response.data.data);
        setLoading(false);
      });
  }, [filters.policyPlanId, filters.teamId, filters.cycleId]);

  return { data, loading };
}
